export function seoApi() {
  const apiVersion = useRuntimeConfig().API_VER_1
  return {
    SEO: `${apiVersion}/brand/seo`,
    BRAND_CONTACT: `${apiVersion}/brand/contact`,
    BRAND_INFO: `${apiVersion}/brand/info`
  }
}
